<section>
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  @if (form) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="astral-content-width astral-stack-l">
      <section class="astral-section-surface astral-stack-m">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [control]="form.controls['name']"></astral-input>
          <astral-select [control]="form.controls['meterType']" [itemsSource]="meterTypeSelection"></astral-select>
          @if (currencySelection && currencySelection.length > 1) {
            <astral-select [control]="form.controls['currencyCode']" [itemsSource]="currencySelection"></astral-select>
          }
          <astral-select [control]="form.controls['articleId']" [itemsSource]="articleSelection"></astral-select>
        </astral-layout-group>
      </section>

      @if (isNew) {
        <app-information-block [text]="'CONSUMPTION.PRICELIST.PRICE_INFORMATION' | translate"></app-information-block>
        <section class="astral-section-surface astral-stack-m">
          <astral-button variant="primary" icon="plus" labelKey="ADD_MORE" type="button" (click)="addPrice()"></astral-button>
          <app-list-view
            [columnDefinition]="priceColumnDefinition"
            [itemsSource]="priceItems"
            [preferencesKey]="'consumption.imd-pricelist.prices.list'"
            (rowClick)="onPriceRowClicked($any($event))"
          ></app-list-view>
        </section>
      } @else {
        <div class="astral-accordion-stack">
          <astral-accordion [header]="'CONSUMPTION.PRICELIST.PRICES'" [startExpanded]="true" [allowWidthExpansion]="true">
            <div class="astral-stack-m">
              <app-information-block [text]="'CONSUMPTION.PRICELIST.PRICE_INFORMATION' | translate"></app-information-block>
              <astral-button variant="primary" icon="plus" labelKey="ADD_MORE" type="button" (click)="addPrice()"></astral-button>
              <app-list-view
                [columnDefinition]="priceColumnDefinition"
                [itemsSource]="priceItems"
                [pageSize]="5"
                [pageSizeOptions]="[5, 20, 50, 100]"
                [preferencesKey]="'consumption.imd-pricelist.prices.list'"
                (rowClick)="onPriceRowClicked($any($event))"
              ></app-list-view>
            </div>
          </astral-accordion>

          <astral-accordion [header]="'CONSUMPTION.PRICELIST.USAGE'" [allowWidthExpansion]="true">
            <div class="astral-stack-m">
              <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
                <astral-select [control]="propertyControl" [itemsSource]="propertySelection"></astral-select>
              </astral-layout-group>
              @if (propertyControl?.value) {
                <app-list-view
                  [columnDefinition]="rentalObjectColumnDefinition"
                  [itemsSource]="rentalObjects"
                  [preferencesKey]="'consumption.imd-pricelist.rental-objects.list'"
                ></app-list-view>
              }
            </div>
          </astral-accordion>
        </div>
      }
    </form>
  }
</section>

<ng-template #priceEditorSidebar>
  @if (priceEditorForm) {
    <form [formGroup]="priceEditorForm" (ngSubmit)="savePrice()" class="astral-sidebar-shell" novalidate>
      <div class="astral-sidebar-content astral-stack-l">
        <header>
          @if (editedPriceIndex === null) {
            <h2 class="astral-sidebar-heading">{{ 'CONSUMPTION.PRICELIST.CREATE_PRICE' | translate }}</h2>
          } @else {
            <h2 class="astral-sidebar-heading">{{ 'CONSUMPTION.PRICELIST.EDIT_PRICE' | translate }}</h2>
          }
        </header>
        <astral-layout-group [columns]="1" [mobileColumns]="1" [span]="'full'">
          <astral-date-picker [control]="priceEditorForm.controls['fromDate']"></astral-date-picker>
          <app-money-box [control]="priceEditorForm.controls['amountPerUnit']"></app-money-box>
        </astral-layout-group>
      </div>
      <footer class="astral-sidebar-footer">
        <astral-button variant="primary" type="submit" labelKey="SAVE_BTN"></astral-button>
        @if (editedPriceIndex !== null) {
          <astral-button variant="secondary" icon="trash" type="button" labelKey="DELETE_BTN" (click)="deletePrice()"></astral-button>
        }
        <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="cancelPriceEditor()"></astral-button>
      </footer>
    </form>
  }
</ng-template>
